'use client';

import {
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Box,
} from '@mui/material';
import Link from 'next/link';
import { proyectosData } from '@/data/proyectos/proyectosData';

export default function HidrologiaPage() {
  
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Título de la página */}
      <Box textAlign="center" mb={6}>
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{
            fontWeight: 700,
            color: 'primary.main'
          }}
        >Proyectos
        </Typography>
        <Typography
          variant="h6"
          color="text.secondary"
          sx={{ maxWidth: '800px', mx: 'auto' }}
        >
          Sistemas especializados para el monitoreo y análisis de la calidad del agua en diferentes entornos y condiciones.
        </Typography>
      </Box>

      {/* Grid de Cards - SIN Grid2 */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 4,
        }}
      >
        {proyectosData.map((sistema, index) => (
          
          <Card key={index} sx={{
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            transition: 'transform 0.2s, box-shadow 0.2s',
            opacity: sistema.hasPage ? 1 : 0.7, // Indica visualmente si no tiene página
            '&:hover': { 
              transform: sistema.hasPage ? 'translateY(-4px)' : 'none',
              boxShadow: sistema.hasPage ? '0 8px 16px rgba(0,0,0,0.1)' : 'none'
            }
          }}>

            <CardMedia 
              component="img" 
              height="240" 
              image={sistema.imagen} 
              alt={sistema.titulo} 
              sx={{ objectFit: 'cover' }} 
            />

            <CardContent sx={{ flexGrow: 1 }}>
              <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, color: 'primary.main' }}>
                {sistema.titulo}
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                {sistema.descripcion}
              </Typography>
            </CardContent>

            <Box sx={{ p: 2 }}>
              {sistema.hasPage ? (
                <Link 
                  href={`/proyectos/${encodeURIComponent(sistema.titulo.toLowerCase())}`} 
                  style={{ textDecoration: 'none' }}
                >
                  <Box sx={{ 
                    textAlign: 'center', 
                    py: 1, 
                    px: 2, 
                    backgroundColor: 'primary.main', 
                    color: 'white', 
                    borderRadius: 1, 
                    cursor: 'pointer', 
                    '&:hover': { backgroundColor: 'primary.dark' } 
                  }}>
                    Ver más
                  </Box>
                </Link>
              ) : (
                <Box sx={{ 
                  textAlign: 'center', 
                  py: 1, 
                  px: 2, 
                  backgroundColor: 'grey.300', 
                  color: 'grey.600', 
                  borderRadius: 1,
                  cursor: 'not-allowed'
                }}>
                  Próximamente
                </Box>
              )}
            </Box>
          </Card>
        ))}
      </Box>
    </Container>
  );
}